import { SimpleVenueData, VenueData } from '../../../shared/dto/EntityRepository';
import { UpdateVenueReq } from '../../../shared/dto/ReqDtoRepository';

const text = (value?: string | null) => (value ?? '').trim();

const toCoord = (value: number | null): number | null => {
  if (value == null || !Number.isFinite(value)) return null;
  return Number.parseFloat(value.toFixed(6));
};

export const isVenueDetail = (
  venue: VenueData | SimpleVenueData,
): venue is VenueData => Array.isArray((venue as VenueData).openingHours);

export const normalizeVenueDetail = (venue: VenueData): VenueData => ({
  ...venue,
  id: String(venue.id),
  name: venue.name ?? '',
  nameEn: venue.nameEn ?? '',
  countryCode: venue.countryCode ?? '',
  city: venue.city ?? '',
  district: venue.district ?? '',
  roadAddress: venue.roadAddress ?? '',
  roadAddressEn: venue.roadAddressEn ?? '',
  timeZone: venue.timeZone ?? '',
  instagramUrl: venue.instagramUrl ?? '',
  websiteUrl: venue.websiteUrl ?? '',
  phoneNumber: venue.phoneNumber ?? '',
  description: venue.description ?? '',
  descriptionEn: venue.descriptionEn ?? '',
  naverMapUrl: venue.naverMapUrl ?? '',
  googleMapUrl: venue.googleMapUrl ?? '',
  admissionNote: venue.admissionNote ?? '',
  openingHoursNote: venue.openingHoursNote ?? '',
  openingHours: venue.openingHours ?? [],
  tags: venue.tags ?? [],
});

export const toUpdateVenueReq = (detail: VenueData): UpdateVenueReq => ({
  name: text(detail.name),
  type: detail.type,
  countryCode: text(detail.countryCode),
  city: text(detail.city),
  roadAddress: text(detail.roadAddress),
  timeZone: text(detail.timeZone),
  lifecycleStatus: detail.lifecycleStatus,
  admissionType: detail.admissionType,
  openingHours: detail.openingHours ?? [],
  nameEn: text(detail.nameEn),
  district: text(detail.district),
  roadAddressEn: text(detail.roadAddressEn),
  latitude: toCoord(detail.latitude),
  longitude: toCoord(detail.longitude),
  instagramUrl: text(detail.instagramUrl),
  websiteUrl: text(detail.websiteUrl),
  phoneNumber: text(detail.phoneNumber),
  description: text(detail.description),
  descriptionEn: text(detail.descriptionEn),
  naverMapUrl: text(detail.naverMapUrl),
  googleMapUrl: text(detail.googleMapUrl),
  admissionNote: text(detail.admissionNote),
  openingHoursNote: text(detail.openingHoursNote),
  tagIds: detail.tags.map((tag) => tag.id),
});

const toDraftSnapshot = (detail: VenueData) => {
  const req = toUpdateVenueReq(detail);
  return JSON.stringify({
    ...req,
    tagIds: [...(req.tagIds ?? [])].sort((left, right) => left - right),
  });
};

export const isSameVenueDraft = (left: VenueData, right: VenueData): boolean =>
  toDraftSnapshot(left) === toDraftSnapshot(right);
